import { ShieldCheck, Layers, MapPin } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { useLang } from "@/i18n";

const CLINIC_IMG = "/clinic-storefront.jpg";

const ICONS = [ShieldCheck, Layers, MapPin];

export default function WhyUs() {
    const { t } = useLang();

    return (
        <section className="relative bg-brand-olivelight/60 py-24 md:py-32">
            <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 md:px-8 lg:grid-cols-12">
                <Reveal className="relative lg:col-span-5">
                    <div className="overflow-hidden rounded-[2rem] border border-brand-accentline shadow-lift">
                        <img
                            src={CLINIC_IMG}
                            alt="Signita Wellness storefront — clinic and chemist on Ghodbunder Road"
                            loading="lazy"
                            className="h-[420px] w-full object-cover md:h-[520px]"
                        />
                    </div>
                    <div className="absolute -bottom-6 right-6 rounded-2xl bg-brand-navy px-6 py-5 text-white shadow-lift">
                        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-brand-lime">{t.why.chipTop}</p>
                        <p className="mt-1 text-sm font-semibold">{t.why.chip}</p>
                    </div>
                </Reveal>

                <div className="lg:col-span-7 lg:pl-10">
                    <Reveal>
                        <Eyebrow>{t.why.eyebrow}</Eyebrow>
                        <h2 className="mt-4 font-display text-4xl font-semibold leading-[1.08] tracking-tight text-brand-navy md:text-5xl">
                            {t.why.h2a} <em className="italic text-brand-olive">{t.why.h2b}</em>
                        </h2>
                    </Reveal>

                    <div className="mt-12 space-y-2">
                        {t.why.points.map((p, i) => {
                            const Icon = ICONS[i];
                            return (
                                <Reveal key={p.title} delay={0.1 + i * 0.08}>
                                    <div className="group flex gap-5 rounded-2xl border border-transparent p-5 transition-all duration-300 hover:border-brand-accentline hover:bg-white">
                                        <span className="mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white text-brand-olive shadow-sm transition-colors duration-300 group-hover:bg-brand-olive group-hover:text-white">
                                            <Icon className="h-5 w-5" />
                                        </span>
                                        <div>
                                            <h3 className="text-base font-bold text-brand-navy md:text-lg">{p.title}</h3>
                                            <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{p.text}</p>
                                        </div>
                                    </div>
                                </Reveal>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}
